import { Link } from "react-router-dom";
import IntranetLayout from "@/components/IntranetLayout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileText, ClipboardList, Sparkles, ArrowRight } from "lucide-react";
import { DocumentControllerContent } from "./DocumentController";
import AIManagerPanel from "@/components/ai/AIManagerPanel";

const DocumentsHub = () => {
  return (
    <IntranetLayout>
      <div className="mb-4">
        <h1 className="text-2xl font-bold text-[#00283C] font-display">Documents & SOPs Hub</h1>
        <p className="text-sm text-muted-foreground">Document Controller workspace + Vel-iO Document Controller. Every AI action is queued for your approval.</p>
      </div>

      <Tabs defaultValue="ai" className="w-full">
        <TabsList className="bg-[#F4F7FA] mb-4">
          <TabsTrigger value="ai"><Sparkles className="w-4 h-4 mr-1" /> Vel-iO Document Controller</TabsTrigger>
          <TabsTrigger value="controller"><ClipboardList className="w-4 h-4 mr-1" /> Document Controller</TabsTrigger>
          <TabsTrigger value="library"><FileText className="w-4 h-4 mr-1" /> Document Library</TabsTrigger>
        </TabsList>

        <TabsContent value="ai" className="mt-0">
          <AIManagerPanel
            hub="documents"
            title="Vel-iO Document Controller"
            subtitle="I track acknowledgement rates, flag overdue revisions, draft change summaries and reminders — pending your sign-off."
            accent="text-[#288CC8]"
            context="Hub: Document Controller. Focus on SMS, OPS, MNT, CRW, COMP and Corp documents. Track acknowledgement rates, review-due dates, OVMSA2/ISM compliance gaps, draft revisions for overdue documents."
          />
        </TabsContent>

        <TabsContent value="controller" className="mt-0">
          <DocumentControllerContent />
        </TabsContent>

        <TabsContent value="library" className="mt-0">
          <Card className="border-[#D0DDE6]">
            <CardContent className="p-8 text-center space-y-4">
              <FileText className="w-12 h-12 mx-auto text-[#288CC8]" />
              <h3 className="text-xl font-bold text-[#00283C]">Full Document Library</h3>
              <p className="text-sm text-muted-foreground max-w-xl mx-auto">
                Browse the full controlled-document library — Class & Flag, Corporate Governance, DP Governance, SMS, QMS, Security and more — with reading-time tracking and acknowledgements.
              </p>
              <Button asChild className="bg-[#288CC8] hover:bg-[#288CC8]/90">
                <Link to="/employee/documents">Open Library <ArrowRight className="w-4 h-4 ml-1" /></Link>
              </Button>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </IntranetLayout>
  );
};

export default DocumentsHub;
